(function () {
  'use strict';

  var cfg = window.QCCartEnhancements || {};
  if (!cfg.comboEnabled || !Array.isArray(cfg.groups) || !cfg.groups.length) return;

  var groups = cfg.groups
    .filter(function (group) { return group && Array.isArray(group.variants) && group.variants.length; })
    .map(function (group, index) {
      return {
        index: index,
        title: group.title || 'Combo offer',
        url: group.url || '#',
        variants: new Set(group.variants.map(Number))
      };
    });

  if (!groups.length) return;

  function extractVariantIds(body) {
    var ids = [];
    if (!body) return ids;

    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var formId = body.get('id');
        if (formId) ids.push(Number(formId));
        body.forEach(function (value, key) {
          if (/items\[\d+\]\[id\]/.test(key)) ids.push(Number(value));
        });
        return ids.filter(Boolean);
      }

      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        var urlId = body.get('id');
        if (urlId) ids.push(Number(urlId));
        return ids.filter(Boolean);
      }

      if (typeof body === 'string') {
        try {
          var parsed = JSON.parse(body);
          if (parsed.id) ids.push(Number(parsed.id));
          if (Array.isArray(parsed.items)) {
            parsed.items.forEach(function (item) {
              if (item && item.id) ids.push(Number(item.id));
            });
          }
          return ids.filter(Boolean);
        } catch (jsonError) {
          var params = new URLSearchParams(body);
          var stringId = params.get('id');
          if (stringId) ids.push(Number(stringId));
        }
      }
    } catch (e) {
      return [];
    }

    return ids.filter(Boolean);
  }

  function matchingGroups(ids) {
    var matches = [];
    groups.forEach(function (group) {
      if (ids.some(function (id) { return group.variants.has(Number(id)); })) matches.push(group);
    });
    return matches;
  }

  function getModal() {
    var existing = document.getElementById('qc-combo-offer-modal');
    if (existing) return existing;

    var modal = document.createElement('div');
    modal.id = 'qc-combo-offer-modal';
    modal.className = 'qc-combo-modal';
    modal.hidden = true;
    modal.innerHTML = '' +
      '<div class="qc-combo-modal__backdrop" data-qc-close></div>' +
      '<div class="qc-combo-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="qc-combo-title">' +
        '<button type="button" class="qc-combo-modal__close" aria-label="Close" data-qc-close>&times;</button>' +
        '<h3 class="qc-combo-modal__title" id="qc-combo-title"></h3>' +
        '<p class="qc-combo-modal__message"></p>' +
        '<a class="qc-combo-modal__cta" href="#"></a>' +
      '</div>';

    document.body.appendChild(modal);
    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-qc-close]')) hideModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) hideModal();
    });
    return modal;
  }

  function hideModal() {
    var modal = document.getElementById('qc-combo-offer-modal');
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.style.removeProperty('overflow');
  }

  function showModal(group) {
    var modal = getModal();
    var title = modal.querySelector('.qc-combo-modal__title');
    var message = modal.querySelector('.qc-combo-modal__message');
    var cta = modal.querySelector('.qc-combo-modal__cta');

    title.textContent = cfg.heading || 'Complete your combo';
    message.innerHTML = '<span class="qc-combo-modal__offer">' + escapeHtml(group.title) + ':</span> ' + escapeHtml(cfg.message || 'Select one more pair to activate this offer.');
    cta.textContent = cfg.cta || 'Select one more pair';
    cta.href = group.url || '#';

    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { cta.focus(); }, 30);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function checkGroup(group) {
    return window.fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var eligibleQty = 0;
        (cart.items || []).forEach(function (item) {
          if (group.variants.has(Number(item.variant_id || item.id))) {
            eligibleQty += Number(item.quantity || 0);
          }
        });
        if (eligibleQty > 0 && eligibleQty % 2 === 1) showModal(group);
      })
      .catch(function () {});
  }

  var originalFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
    var isCartAdd = /\/cart\/add(?:\.js)?(?:\?|$)/.test(url);
    var addedIds = isCartAdd ? extractVariantIds(init && init.body) : [];
    var affectedGroups = addedIds.length ? matchingGroups(addedIds) : [];

    return originalFetch(input, init).then(function (response) {
      if (response.ok && affectedGroups.length) {
        setTimeout(function () {
          checkGroup(affectedGroups[0]);
        }, 450);
      }
      return response;
    });
  };
})();
